import { render } from "./circular-pie-v3.vue?vue&type=template&id=025561e8&scoped=true"
import script from "./circular-pie-v3.vue?vue&type=script&lang=js"
export * from "./circular-pie-v3.vue?vue&type=script&lang=js"

import "./circular-pie-v3.vue?vue&type=style&index=0&id=025561e8&lang=scss&scoped=true"

import exportComponent from "/Users/jigarpyunt/Desktop/ArrowDT/Git/SDB/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-025561e8"]])

export default __exports__